<template>
   <div id="content">
      <div class="container mb-5">
         <div class="row align-items-center my-5">
            <div class="w-max-content text-center px-2 pt-1">
               <!-- <img src="@/assets/images/icon.png" alt="Mooli Logo" class="img-fluid logo"><span class="d-block">Sindfy</span> -->
            </div>
            <div class="col px-2">
               <i class="far fa-angle-right font-21 color-theme mr-3"></i>
               <span class="text-center my-0 font-23 d-none d-sm-inline">Selecione uma escola</span>
               <span class="text-center my-0 font-23 d-inline d-sm-none">Escolas</span>
            </div>
            <div class="w-max-content text-center px-2 pt-1">
               <a href="javascript:;" @click="deslogar"><i class="far fa-sign-out font-20 d-block color-theme"></i>Sair</a>
            </div>
         </div>
         
         <div v-if="dadosUsuario.usuarioEscolas.length > 0">
            <div class="cards">
               <div v-for="(u, index) in dadosUsuario.usuarioEscolas" :key="index" :index="index" v-show="!u.deletado" class="card btnHover">
                  <div class="mt-2 mb-2 cursor-pointer pr-3 pl-3" @click="escolaSelecionada(u)">
                     <div class="d-flex justify-content-center">
                        <img src="@/assets/images/security.png" alt="Mooli Logo" v-if="u.id == 0">
                        <img src="@/assets/images/school.png" alt="Mooli Logo" class="d-flex justify-content-center img-fluid logo" v-else>
                     </div>
                     <div class="d-flex justify-content-center mt-3 ">
                        <span class="font-16 font-weight-bold">{{u.nome}}</span>
                     </div>
                     <div class="d-flex justify-content-center">
                        <span class="font-italic unicoLimitador">{{u.endereco}}</span>
                     </div>
                  </div>
               </div>
            </div>
         </div> 
      </div>
   </div>
</template>

<script>

import $ from 'jquery'
import { mapState } from 'vuex'

export default {
	name: 'Escolas',
   data: function() {
		return {
         modal: {'id': null, 'nome': '', 'cnpj': '', 'cep': '', 'endereco': '', 'numero': '', 'bairro': '', 'cidade': '', 'estado': '', 'tipo': 'Vertical', 'area': '', 'dataEntrega': '', 'telefones': []},
         modalConfig: {'advanced': false, 'addTelefone': false},
         telefone: {'id': null, 'ddd': '', 'telefone': '', 'tipo': ''},
         escolaAdmin: {'deletado': false, 'endereco': '', 'id': 0, 'nome': ''}
		}
	},
   computed: {
      ... mapState({
         dadosUsuario: state => state.dadosUsuario,
         tokenSessao: state => state.tokenSessao,
         urlRest: state => state.urlRest,
         dadosEscola: state => state.dadosEscola
      })
	},
   components: {
      
   },
   methods: {
      deslogar : function () {
			this.$store.dispatch('deslogar')
      },
      escolaSelecionada(u) {
         this.$store.dispatch('escolaSelecionada', u)
      },
      getPermissoesUsuario : function (condominio) {
         this.$store.dispatch('getPermissoesUsuario', condominio);
		},
      buscarCEP : function () {
         let ref = this;

         if (String(this.modal.cep).trim().length < 8) {
            return;
         }

         this.$store.dispatch('buscarCEP', this.modal.cep).then(function(data) {
            ref.modal.endereco = data.logradouro;
            ref.modal.bairro = data.bairro;
            ref.modal.cidade = data.localidade;
            ref.modal.estado = data.uf;
			})
      },
      adicionar : function () {
         this.modal = {'id': null, 'nome': '', 'cnpj': '', 'cep': '', 'endereco': '', 'numero': '', 'bairro': '', 'cidade': '', 'estado': '', 'tipo': 'Vertical', 'area': '', 'dataEntrega': '', 'telefones': []}
         $('#modalCondominio').modal('show')
      },
      editar : function (condominio) {
         this.modal = {
            'id': condominio.id,
            'nome': condominio.nome,
            'cnpj': condominio.cnpj,
            'cep': condominio.endereco.cep,
            'endereco': condominio.endereco.endereco,
            'numero': condominio.endereco.numero,
            'bairro': condominio.endereco.bairro,
            'cidade': condominio.endereco.cidade,
            'estado': condominio.endereco.estado,
            'tipo': condominio.tipo,
            'area': condominio.area,
            'dataEntrega': (condominio.dataEntrega != null ? new Date(condominio.dataEntrega.year +'/'+ condominio.dataEntrega.monthValue +'/'+ condominio.dataEntrega.dayOfMonth).toLocaleDateString() : null),
            'telefones': condominio.telefones
         }

         $('#modalCondominio').modal('show')
		},
      salvar : function () {
         if (this.modal.nome == null || this.modal.nome.trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Nome inválido!'
            })

            return
         } else if (this.modal.tipo == null) {
            this.$toast.fire({
               icon: 'error',
               title: 'Tipo inválido!'
            })

            return
         } else if (this.modal.cnpj == null || this.modal.cnpj.trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'CPF/CNPJ inválido!'
            })

            return
         }

         let ref = this;
			this.$store.dispatch('alternarTelaCarregamento', true)

         this.$axios({
            method: 'post',
            url: this.urlRest +'condominio/saveCondominio',
            headers: {
               'Authorization': 'Bearer '+ this.tokenSessao +'@@@'+ this.dadosUsuario.usuarioemail,
					'Content-Type': 'application/json'
            },
				data: this.modal

         }).then(function (response) {
            ref.$store.dispatch('atualizarCondominios', response.data)
				$('#modalCondominio').modal('hide')

            ref.$toast.fire({
               icon: 'success',
               title: 'Condomínio salvo!'
            })
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else if (error.response.status == 400) {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Data entrega inválida!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  })
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               })
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         })
      },
      addTelefone : function () {
         this.telefone.id = Math.floor(Math.random() * 999999999)

         setTimeout(() => {
            this.modal.telefones.push(this.telefone)
            this.modalConfig.addTelefone = false;
            
            setTimeout(() => {
               this.telefone = {'id': null, 'ddd': '', 'telefone': '', 'tipo': ''}
            }, 100);
         }, 100);
      },
      deletarTelefone : function (idTelefone) {
         let telefones = JSON.parse(JSON.stringify(this.modal.telefones));
         let indexToRemove = this.modal.telefones.findIndex(telefone => {
            return telefone.id == idTelefone;
         });

         this.modal.telefones = []
         telefones.splice(indexToRemove, 1)

         setTimeout(() => {
            this.modal.telefones = telefones;
         }, 100);
      }
   }
}

</script>

<style scoped>
.unicoLimitador {
	overflow: hidden !important;
	display: -webkit-box !important;
	-webkit-line-clamp: 1 !important;
	-webkit-box-orient: vertical !important;
	line-break: anywhere !important;
}

#content {
	height: 100vh;
	width: 100vw;
   display: flex;
   overflow: auto;
}

.row {
	margin: 0;
}

.row>div {
	padding: 0;
}

.cards img {
   height: 100px;
   width: 100px;
}

img {
   width: 25px;
}

.fa-angle-right {
   transform: translateY(1px);
}

.btnHover:hover {
   background-color: rgb(63, 63, 63);
   color: white
}
</style>